import { render, staticRenderFns } from "./user-device.vue?vue&type=template&id=38187cfd&scoped=true"
import script from "./user-device.vue?vue&type=script&lang=ts"
export * from "./user-device.vue?vue&type=script&lang=ts"
import style0 from "./user-device.vue?vue&type=style&index=0&id=38187cfd&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38187cfd",
  null
  
)

export default component.exports